module.exports = __webpack_public_path__ + "static/img/ax.c26f8374.svg";